import classNames from 'classnames'
import React from 'react'
import mappyLogoFilled from '../genericComponents/assets/mappy-logo-filled.svg'
import T from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'
import s from './MyPosition.less'
import { useSelector } from 'react-redux'
import { selectGeolocationStatus } from '../../store/geolocation/geolocation.selectors'
import { GEOLOC_STATUS_BLOCKED } from '../../store/map/map.constants'

const MyPosition = ({ onClick }) => {
  const isBlockedStatus = useSelector(selectGeolocationStatus) === GEOLOC_STATUS_BLOCKED

  return (
    <div className={s.root} onClick={onClick}>
      <div className={s.labelLine}>
        <span className={classNames('icon', s.icon)}>
          <SVGIcon url={mappyLogoFilled} />
        </span>
        <span className={s.label}>
          <T id={'suggest.my-position'} />
        </span>
      </div>
      {isBlockedStatus && (
        <div className={s.error}>
          <T id={'geolocation.error'} />
        </div>
      )}
    </div>
  )
}

export default MyPosition
